/** The type of report available to the Committee Report route. */
export enum CommitteeReportType {
  /** House Report */
  HRPT = 'hrpt',

  /** Senate Report */
  SRPT = 'srpt',

  /** Senate Executive Report */
  ERPT = 'erpt'
}
